import { Typography } from '@mui/material';
import styled from 'styled-components';

interface Props {
  $colorName?: string;
  $fontSizeMobile?: string;
  $lineHeightMobile?: string;
  $fontWeight?: number | string;
}

const Heading6 = styled(Typography) <Props>`
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: ${props => props.$fontWeight || 600};
    font-size: 16px;
    line-height: 18px;
    color: ${props => `var(${props.$colorName || '--black'})`};
    @media only screen and (max-width: 767px) {
      font-size: ${props => props.$fontSizeMobile || "16px"};
      line-height: ${props => props.$lineHeightMobile || "18px"};
    }
`

export default Heading6;